import React from 'react';
import { TutoSmartphoneWrapper } from 'components/install-app-tuto/tuto-smartphone/TutoSmartphone.styled';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/button/Button';
import { APP_STORES } from 'constants/global';
import useAutoLoginUrl from 'hooks/useAutoLoginUrl';
import { acknowledgeQuestionnaireEnd } from 'helpers/utils';

export interface TutoSmartphoneProps {
  isIOS?: boolean;
}

const TutoSmartphone: React.FC<TutoSmartphoneProps> = ({ isIOS }) => {
  const { t } = useTranslation('translation');
  const autoLoginUrl = useAutoLoginUrl();
  const storeUrl = isIOS ? APP_STORES.IOS : APP_STORES.ANDROID;

  return (
    <TutoSmartphoneWrapper>
      <ol className="steps">
        {/* Step 1: download the app from the store matching the device */}
        <li className="step">
          <div className="step-number">{t('common.step', { number: 1 })}</div>
          <p className="step-hint">{t('settings.installation.steps.download.smartphone_hint')}</p>
          <Button color="white" expand href={storeUrl} target="_blank">
            {t('settings.installation.steps.download.smartphone_cta')}
          </Button>
        </li>
        {/* Step 2: open the auto-login link inside the installed app */}
        <li className="step">
          <div className="step-number">{t('common.step', { number: 2 })}</div>
          <p className="step-hint">{t('settings.installation.steps.credentials.smartphone_hint')}</p>
          <Button
            color="white"
            expand
            href={autoLoginUrl || undefined}
            target="_blank"
            disabled={!autoLoginUrl}
            onClick={acknowledgeQuestionnaireEnd}
          >
            {t('settings.installation.steps.credentials.smartphone_cta')}
          </Button>
        </li>
      </ol>
    </TutoSmartphoneWrapper>
  );
};

export default TutoSmartphone;
